import './application.css'
import { createRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx')
    const pagePath = `../pages/${name}.tsx`
    const page = pages[pagePath]
    if (!page) {
      console.error(`Page not found: ${name} (looking for ${pagePath})`)
      throw new Error(`Page not found: ${name}`)
    }
    return page().then((module: any) => module.default)
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
